export enum TabItemPanel {
  DEFAULT = 'default',
  FILL = 'fill',
  OUTLINE = 'outline',
  FONT = 'font',
  BACKGROUND_COLOR = 'background-color',
  SEPARATOR = 'separator',
  ANIMATION = 'animation',
}
